import React, { Component } from "react";
import { NavBar, SideBar, Footer } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import PouchDB from "pouchdb";
import PouchdbFind from "pouchdb-find";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import moment from "moment";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from "reactstrap";
PouchDB.plugin(PouchdbFind);

const MODAL_DELETAR_PERFIL = "modalDeletarPerfil";

export default class Perfil extends Component {
  constructor(props) {
    super(props);
    this.load = this.load.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.notificar = this.notificar.bind(this);
    this.handleClickDeletar = this.handleClickDeletar.bind(this);
    this.loadPerfis = this.loadPerfis.bind(this);
    this.handleClickDeletarConfirma =
      this.handleClickDeletarConfirma.bind(this);
    this.abrirPaginaCadastro = this.abrirPaginaCadastro.bind(this);

    this.state = {
      modal: {
        [MODAL_DELETAR_PERFIL]: false,
      },
      perfis: [],
      perfilSelecionado: null,
    };
  }

  async componentDidMount() {
    await this.load();
  }

  async load() {
    this.loadPerfis();
  }

  toggleModal(type) {
    let modal = this.state.modal;
    modal[type] = !modal[type];
    this.setState({ modal });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  async handleClickDeletar(perfil) {
    this.setState({ perfilSelecionado: perfil }, () => {
      this.toggleModal(MODAL_DELETAR_PERFIL);
    });
  }

  async handleClickDeletarConfirma() {
    await axios
      .delete(
        `${this.props.getBaseUrlApi()}/perfis/${
          this.state.perfilSelecionado._id
        }`,
        this.props.parameters()
      )
      .then((response) => {
        this.toggleModal(MODAL_DELETAR_PERFIL);
        this.notificar("success", "Perfil deletado com sucesso!");
        this.load();
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 422) {
            this.notificar("warning", error.response.data.erro);
            this.toggleModal(MODAL_DELETAR_PERFIL);
          }
          if (error.response.status === 401) {
            this.props.logout();
          }
        }
      });
  }

  async loadPerfis() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/perfis?incluirusuarios=true`,
        this.props.parameters()
      )
      .then((response) => {
        this.setState({ perfis: response.data.perfis });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push("/home");
          }
        }
      });
  }

  abrirPaginaCadastro(id = null) {
    let url = "/perfis-novo";
    if (id !== null) {
      url = `${url}?id=${id}`;
    }
    this.props.history.push(url);
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="Perfis de Acesso" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"perfis"} />
            <div className="main-panel">
              <div className="content-wrapper">
                <div className="row font-size-13">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        <div className="tab-content py-0 px-0">
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div
                                style={{
                                  padding: "15px",
                                  float: "left",
                                  width: "100%",
                                }}
                              >
                                <div
                                  style={{
                                    float: "left",
                                    width: "100%",
                                    backgroundColor: "#fafbfc",
                                  }}
                                >
                                  <table
                                    className="table table-hover table-striped"
                                    style={{ fontSize: "15px" }}
                                  >
                                    <thead className="thead-dark">
                                      <tr>
                                        <th style={{}}>Descrição</th>
                                        <th className="text-center">
                                          Qtd Usuários
                                        </th>
                                        <th className="text-center">
                                          Data Cadastro
                                        </th>
                                        <th className="text-center">Ações</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.perfis.map((perfil, key) => (
                                        <tr key={key}>
                                          <td>{perfil.desc}</td>
                                          <td className="text-center">
                                            {perfil.usuarios.length}
                                          </td>

                                          <td className="text-center">
                                            {moment(perfil.dtCadastro).format(
                                              "DD/MM/YYYY HH:mm"
                                            )}
                                          </td>

                                          <td className="">
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                              }}
                                            >
                                              <div
                                                onClick={() =>
                                                  this.handleClickDeletar(
                                                    perfil
                                                  )
                                                }
                                                style={{ margin: "3px" }}
                                              >
                                                <i
                                                  className="fa fa-times"
                                                  style={{
                                                    cursor: "pointer",
                                                    color: "red",
                                                    fontSize: "18px",
                                                  }}
                                                  id={`excluir-perfil-${perfil._id}`}
                                                ></i>
                                                <UncontrolledTooltip
                                                  placement="right"
                                                  target={`excluir-perfil-${perfil._id}`}
                                                >
                                                  Excluir Perfil
                                                </UncontrolledTooltip>
                                              </div>
                                              <div
                                                onClick={() =>
                                                  this.abrirPaginaCadastro(
                                                    perfil._id
                                                  )
                                                }
                                                style={{ margin: "3px" }}
                                              >
                                                <i
                                                  className="fa fa-edit"
                                                  style={{
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    fontSize: "18px",
                                                  }}
                                                  id={`editar-perfil-${perfil._id}`}
                                                ></i>
                                                <UncontrolledTooltip
                                                  placement="right"
                                                  target={`editar-perfil-${perfil._id}`}
                                                >
                                                  Editar Perfil
                                                </UncontrolledTooltip>
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>

                                <div className="form-group">
                                    <button
                                      className="btn btn-success"
                                      onClick={() => this.abrirPaginaCadastro()}
                                    >
                                      <i
                                        className="fa fa-plus"
                                        aria-hidden="true"
                                      ></i>
                                      &nbsp; Novo Perfil
                                    </button>
                                  </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.modal[MODAL_DELETAR_PERFIL]}
          toggle={() => this.toggleModal(MODAL_DELETAR_PERFIL)}
        >
          <ModalHeader toggle={() => this.toggleModal(MODAL_DELETAR_PERFIL)}>
            Excluir Perfil
          </ModalHeader>
          <ModalBody>Tem certeza que deseja excluir este perfil?</ModalBody>
          <ModalFooter>
            <Button
              color="danger"
              onClick={(e) => this.handleClickDeletarConfirma()}
            >
              Excluir
            </Button>{" "}
            <Button
              color="secondary"
              onClick={() => this.toggleModal(MODAL_DELETAR_PERFIL)}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}
